import gql from "graphql-tag";

const PRODUCTS_QUERY = gql`  
  query Products {
    products {
      id
      name
      description
      code
      cost
      image{
          original
          thumbnail
          zoom
      }
      maxQty
      stepQty
      startDate
      endDate
      createdAt
      updatedAt
      }
    } 
`;

export default PRODUCTS_QUERY;